import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  analyticsLabelFromString,
} from '../../../helpers/adobe-analytics';
export class Patti extends Lit3formBlock {
  static get characterName() {
    return 'patti';
  }

  static get characterProperties() {
    return {
      header: { type: String },
      description: { type: String },
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid patti-layout">
          <div class="description">
            <h2>${unsafeHTML(this.headerText)}</h2>
            <p class="description-text">${unsafeHTML(this.introductionText)}</p>
            <cta-text
              cta-data=${this.ctaData}
              .ctaAnalyticsData=${analyticsCtaDataObject(
                this.ctaData,
                this.headerText
              )}
            ></cta-text>
          </div>
          <div class="image">
            <img src=${this.imagebossUrl(this.imageUrl, '450', null)} />

            <div class="image-caption">
              <span>
                <p>${unsafeHTML(this.imageDescription)}</p>
              </span>
              <span>
                <download-button
                  downloadData=${JSON.stringify({
                    file_format: 'JPG',
                    file_name: analyticsLabelFromString(this.imageDescription),
                    link_url: this.fullResolutionImgUrl,
                    link_type: 'IMAGE',
                    placement: analyticsLabelFromString(this.headerText),
                  })}
                ></download-button>
              </span>
            </div>
          </div>
          ${this.descriptionTextHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get descriptionTextHTML() {
    return !!this.descriptionText
      ? html`
          <div class="text">
            <h3>${unsafeHTML(this.descriptionText)}</h3>
          </div>
        `
      : html``;
  }

  get headerText() {
    return this.content.header || '';
  }

  get introductionText() {
    return this.content.introduction || '';
  }

  get descriptionText() {
    return this.content.description || '';
  }

  get imageUrl() {
    return this.content.image.src || '';
  }

  get fullResolutionImgUrl() {
    return this.content.image.full_resolution_src || '';
  }

  get imageDescription() {
    const regex = /\s*\r\n|\r|\n\s*/gi;
    return this.content.image.description.replaceAll(regex, '<br>');
  }

  get ctaData() {
    return JSON.stringify(this.content.cta);
  }
}
Patti.defineElement();
